import { useState } from 'react';
import { extractDateString } from '../lib/date-utils.js';
import type { KpiTeam } from '../types/api.js';

/** バグ検知日数平均チャートのドリルダウンモーダルの状態 */
interface BugDetectionModalState {
  /** モーダル表示状態 */
  open: boolean;
  /** 対象チーム */
  team: KpiTeam;
  /** チーム表示名 */
  teamDisplayName: string;
  /** ドリルダウン対象日付（YYYY-MM-DD） */
  date: string;
}

/**
 * @graph-stack product-innovation-lab
 * @graph-domain UX
 * @graph-business バグ検知日数平均チャートのドリルダウンモーダルの開閉状態を管理するフック。点クリック時に resolveTeam でチーム情報を解決し、正規化した日付とともにモーダルを開く
 * @graph-connects extractDateString [calls] 日付文字列正規化
 */
export function useBugDetectionModal(
  resolveTeam: () => { team: KpiTeam; teamDisplayName: string },
) {
  const [modal, setModal] = useState<BugDetectionModalState>({
    open: false,
    team: 'all',
    teamDisplayName: '',
    date: '',
  });

  const openModal = (date: unknown) => {
    const { team, teamDisplayName } = resolveTeam();
    setModal({
      open: true,
      team,
      teamDisplayName,
      date: extractDateString(date),
    });
  };

  const closeModal = () => {
    setModal((prev) => ({ ...prev, open: false }));
  };

  return { modal, openModal, closeModal };
}
